module.exports = __webpack_public_path__ + "media/Picked Coin Echo.b05c1059.wav";